import {FirebaseTopicModel} from "../../firebase-topic-model";
import {IIGCLiveProgressUpdate, IIGCLiveProgressUpdateData} from "./live-progress-update-topic.model.interface";
import {IServiceFactoryExtended} from "../../../../service-factory-extended.interface";
import {ITriple8Connection} from "../../../triple8/triple8-connection.inteface";
import {ILiveProgressUpdateTopicViewModel} from "./live-progress-update-topic.view-model.interface";


export class InGameChallengesLiveProgressUpdateModel extends FirebaseTopicModel<IIGCLiveProgressUpdate, IIGCLiveProgressUpdateData> implements ILiveProgressUpdateTopicViewModel {
    constructor(private readonly campaignId: number,
                services: IServiceFactoryExtended,
                getConnection: () => Promise<ITriple8Connection>) {
        super(services, getConnection);
    }
    
    getTopicName(): string {
        return `CampaignsNotification/${this.services.user.cid}_${this.campaignId}`;
    }
    getTopicLabel(): string {
        return "CampaignsNotificationUpdate";
    }
    protected _mapRawMessageToPublishMessage(rawMessage: IIGCLiveProgressUpdate): IIGCLiveProgressUpdateData {
        const data = {
            CampaignId: rawMessage.CampaignId,
            CampaignExpirationDate: rawMessage.CampaignExpirationDate,
            RuleId: rawMessage.RuleId,
            RuleCompletedActions: rawMessage.RuleCompletedActions,
            RuleRequiredActions: rawMessage.RuleRequiredActions,
            CampaignRuleCompleted: rawMessage.CampaignRuleCompleted,
            CampaignRuleRequired: rawMessage.CampaignRuleRequired,
        }
        return data;
    }
}